import { FC } from "react";
import { useParams } from "react-router-dom";
import { useAppSelector } from "hooks";
import { selectDrawerSelectedAccountId } from "app/data/selectors";
import MaintenanceAlertsTableSection from "components/common/objects/MaintenanceAlerts/MaintenanceAlertsTableSection";

const ObjectMaintenanceAlertsSection: FC = () => {
  const { id: objectId } = useParams();
  const accountId = useAppSelector(selectDrawerSelectedAccountId) || "";

  return (
    <MaintenanceAlertsTableSection
      accountId={accountId}
      objectId={objectId}
      variant="object"
    />
  );
};

export default ObjectMaintenanceAlertsSection;
